<template>
  <div>
    <PCNavbar selectIndex="14"/>
    <MobileNavBar :currentActive="13" />
    <greenBuildingCategory/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import greenBuildingCategory from '@/components/service_green_building_category-3/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    greenBuildingCategory
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>